import { format, add, isSameDay, isEqual } from "date-fns";
//If an event has a tasks attribute, you must go through these tasks
//to find the appropriate shift ID. If it does not have tasks, the
//eventId will be the shift ID

export const orderShifts = (shifts, constraints) => {
  const shiftNames = [];
  const missionNames = [];
  if (shifts.length > 0) {
    let formatted = [];
    shifts.forEach((shift) => {
      const start = new Date(shift.start);
      const end = new Date(shift.end);
      const formattedStart = format(start, "HH:mm");
      const formattedEnd = format(end, "HH:mm");
      const title = `${formattedStart} - ${formattedEnd}`;

      if (
        !missionNames.includes(shift.procedureName) &&
        shift.procedureName != null
      ) {
        missionNames.push(shift.procedureName);
      }

      if (
        !shiftNames.includes(shift.procedureName) &&
        shift.procedureName != null
      ) {
        shiftNames.push(shift.procedureName);
      }

      if (!shiftNames.includes(title)) {
        shiftNames.push(title);
      }

      const participants = shift.shiftassignmentSet.map((shiftAssignment) => {
        return {
          ...shiftAssignment,
          shiftAssignmentId: shiftAssignment.id,
        };
      });

      const participantIds =
        participants.length > 0 &&
        participants.map((participant) => participant.employeeId);
      if (participants.length > 0) {
        let newEvent = {
          eventId: shift.id,
          start: start,
          end: end,
          participants: [...participants],
          eventTitle: shift.procedureName != null ? shift.procedureName : title,
          employeeIds: [...participantIds],
          missionId: shift.procedureName,
          procedureName: shift.procedureName,
          calendars: ["month", "day"],
        };

        let empdayViewEvents = {
          eventId: shift.id,
          start: start,
          end: end,
          participants: [...participants],
          eventTitle: title,
          employeeIds: [...participantIds],
          missionId: shift.procedureName,
          procedureName: shift.procedureName,
          calendars: ["employee"],
        };
        formatted.push(empdayViewEvents);

        formatted.push(newEvent);

        participants.forEach((participant) => {
          formatted.push({
            eventId: shift.id,
            start: start,
            end: end,
            participants: [participant],
            employeeIds: [participant.employeeId],
            eventTitle: `${participant.firstName} ${participant.lastName}`,
            missionId: shift.procedureName,
            calendars: ["mission"],
            skills: participant.skillSet.map((e) => e.name),
          });
        });
      } else {
        let newEvent = {
          eventId: shift.id,
          start: start,
          end: end,
          participants: [],
          eventTitle: shift.procedureName != null ? shift.procedureName : title,
          employeeIds: [],
          missionId: shift.procedureName,
          procedureName: shift.procedureName,
          calendars: ["month", "day", "mission"],
        };
        formatted.push(newEvent);
      }
    });

    let monthevents = formatted.filter((e) => e.calendars.includes("month"));
    formatted = formatted.filter((event) => event !== null);
    formatted.sort((a, b) => a.start - b.start);
    formatted = formatted.filter((e) => !e.calendars.includes("month"));
    shiftNames.sort();
    monthevents = aggregateTasks(monthevents);
    formatted = [...formatted, ...monthevents];
    return { formatted, shiftNames, missionNames };
  } else {
    return {
      formatted: [],
      shiftNames: [],
      missionNames: [],
    };
  }
};

export const aggregateTasks = (tasks) => {
  let aggregated = [];
  tasks.sort((a, b) => new Date(a.start) - new Date(b.start));

  tasks.forEach((task) => {
    const taskStart = new Date(task.start);
    const taskEnd = new Date(task.end);
    const priorTask = aggregated.find((aggregatedTask) =>
      isEqual(aggregatedTask.end, taskStart)
    );
    const taskWithSameTimes = aggregated.find(
      (aggregatedTask) =>
        isEqual(aggregatedTask.start, taskStart) &&
        isEqual(aggregatedTask.end, taskEnd)
    );
    if (priorTask) {
      priorTask.end = taskEnd;
    } else if (taskWithSameTimes) {
      return;
    } else {
      aggregated.push({
        ...task,
        start: taskStart,
        end: taskEnd,
      });
    }
  });
  aggregated.sort((a, b) => a.start - b.start);
  return aggregated;
};

export const findGaps = (constraints, tasks) => {
  let gaps = [];
  const needsToBeScheduled = constraints.filter((constraint) => {
    const constraintStart = new Date(constraint.start);
    const constraintEnd = new Date(constraint.end);

    const tasksInConstraintTime = tasks.filter((task) => {
      const taskStart = new Date(task.start);
      const taskEnd = new Date(task.end);
      return (
        (isEqual(constraintStart, taskStart) ||
          (constraintStart < taskStart && constraintEnd > taskStart) ||
          isEqual(constraintEnd, taskEnd) ||
          (constraintStart < taskEnd && constraintEnd > taskEnd)) &&
        task.shiftAssignment.employee.skills.find(
          (skill) => skill.name === constraint.employeeCapability.name
        )
      );
    });

    if (tasksInConstraintTime.length > 1) {
      const aggregatedTasks = aggregateTasks(tasksInConstraintTime);

      if (aggregatedTasks.length > 1) {
        for (let i = 0; i < aggregatedTasks.length; i++) {
          let start;
          let end;
          if (new Date(aggregatedTasks[i].start) > constraintStart) {
            start = constraintStart;
            end = new Date(aggregatedTasks[i].start);
          } else if (
            i === aggregatedTasks.length - 1 &&
            new Date(aggregatedTasks[i].end) < constraintEnd
          ) {
            start = new Date(aggregatedTasks[i].end);
            end = constraintEnd;
          } else if (i !== aggregatedTasks.length - 1) {
            start = new Date(aggregatedTasks[i].end);
            end = new Date(aggregatedTasks[i + 1].start);
          }
          gaps.push({
            skill: constraint.employeeCapability,
            start: start,
            end: end,
            value: constraint.value,
          });
        }
      } else if (aggregatedTasks.length === 1) {
        if (aggregatedTasks[0].start > constraintStart) {
          gaps.push({
            skill: constraint.employeeCapability,
            start: constraintStart,
            end: aggregatedTasks[0].start,
            value: constraint.value,
          });
        }
        if (aggregatedTasks[0].end < constraintEnd) {
          gaps.push({
            skill: constraint.employeeCapability,
            start: aggregatedTasks[0].end,
            end: constraintEnd,
            value: constraint.value,
          });
        }
      }
      const coversConstraint = aggregatedTasks.find(
        (aggregatedTask) =>
          (isEqual(constraintStart, aggregatedTask.start) ||
            constraintStart > aggregatedTask.start) &&
          (isEqual(constraintEnd, aggregatedTask.end) ||
            constraintEnd < aggregatedTask.end)
      );

      return !coversConstraint;
    } else if (tasksInConstraintTime.length === 1) {
      const taskStart = new Date(tasksInConstraintTime[0].start);
      const taskEnd = new Date(tasksInConstraintTime[0].end);

      if (taskStart > constraintStart) {
        gaps.push({
          skill: constraint.employeeCapability,
          start: constraintStart,
          end: taskStart,
          value: constraint.value,
        });
      }

      if (taskEnd < constraintEnd) {
        gaps.push({
          skill: constraint.employeeCapability,
          start: taskEnd,
          end: constraintEnd,
          value: constraint.value,
        });
      }

      return !(
        isEqual(constraintStart, taskStart) && isEqual(constraintEnd, taskEnd)
      );
    } else {
      gaps.push({
        skill: constraint.employeeCapability,
        start: constraintStart,
        end: constraintEnd,
        value: constraint.value,
      });
      return true;
    }
  });
  return { needsToBeScheduled, gaps };
};

// export const formatMissions = (procedureRequirements, resources) => {
//   const currentMissionResources = [...resources];
//   const currentMissionEvents = [];
//   // const currentMissionEvents = [...events];
//   let i = 0;
//   const missionTypes = [];

//   procedureRequirements.forEach((procedureReq) => {
//     const { procedure, procedureemployeeconstraintSet } = procedureReq;

//     if (procedure && procedure.taskSet) {
//       const nonArchived = procedure.taskSet.filter(
//         (task) =>
//           task.shiftAssignment && task.shiftAssignment.isArchived === false
//       );

//       if (nonArchived.length > 0) {
//         const gapData = findGaps(procedureemployeeconstraintSet, nonArchived);
//         const needsToBeScheduled = gapData.needsToBeScheduled;
//         const gaps = gapData.gaps;

//         if (needsToBeScheduled && needsToBeScheduled.length > 0) {
//           currentMissionEvents.push({
//             eventId: procedure.id,
//             procedureRequirementId: procedureReq.id,
//             eventTitle: procedureReq.name,
//             start: new Date(procedure.start),
//             end: new Date(procedure.end),
//             missionId: procedureReq.name,
//             employeeIds: [],
//             participants: [],
//             calendars: ["month"],
//             tasks: [],
//             gaps: gaps,
//             notes: procedure.notes,
//           });
//         }

//         currentMissionEvents.push({
//           eventId: procedure.id,
//           eventTitle: procedureReq.name,
//           start: new Date(procedure.start),
//           end: new Date(procedure.end),
//           missionId: procedureReq.name,
//           employeeIds: nonArchived.map(
//             (task) => task.shiftAssignment.employee.id
//           ),
//           participants: nonArchived.map(
//             (task) => task.shiftAssignment.employee
//           ),
//           calendars: ["mission", "month"],
//           tasks: nonArchived,
//           constraints: procedureemployeeconstraintSet,
//           notes: procedure.notes,
//         });

//         nonArchived.forEach((task) => {
//           currentMissionEvents.push({
//             eventId: task.shiftAssignment.shift.id,
//             eventTitle: `${task.shiftAssignment.employee.firstName} ${task.shiftAssignment.employee.lastName}`,
//             start: new Date(task.start),
//             end: new Date(task.end),
//             missionId: procedureReq.name,
//             employeeIds: [task.shiftAssignment.employee.employeeId],
//             participants: [task.shiftAssignment.employee],
//             calendars: ["mission", "employee"],
//             constraints: procedureemployeeconstraintSet,
//           });

//           const shiftExists = currentMissionEvents.find(
//             (event) =>
//               isEqual(event.start, new Date(task.start)) &&
//               isEqual(event.end, new Date(task.end)) &&
//               event.missionId === procedureReq.name &&
//               event.tasks &&
//               event.calendars.includes("day")
//           );
//           if (shiftExists) {
//             shiftExists.tasks = [...shiftExists.tasks, task];
//             shiftExists.employeeIds = [
//               ...shiftExists.employeeIds,
//               task.shiftAssignment.employee.id,
//             ];
//             shiftExists.participants = [
//               ...shiftExists.participants,
//               task.shiftAssignment.employee,
//             ];
//           } else {
//             currentMissionEvents.push({
//               eventId: procedure.id,
//               eventTitle:
//                 format(new Date(task.start), "HH:mm") +
//                 " - " +
//                 format(new Date(task.end), "HH:mm"),
//               start: new Date(task.start),
//               end: new Date(task.end),
//               missionId: procedureReq.name,
//               employeeIds: [task.shiftAssignment.employee.id],
//               participants: [task.shiftAssignment.employee],
//               tasks: [task],
//               calendars: ["day"],
//               constraints: procedureemployeeconstraintSet,
//             });
//           }
//         });
//       } else {
//         currentMissionEvents.push({
//           eventId: procedure.id,
//           procedureRequirementId: procedureReq.id,
//           eventTitle: procedureReq.name,
//           start: new Date(procedure.start),
//           end: new Date(procedure.end),
//           missionId: procedureReq.name,
//           employeeIds: [],
//           participants: [],
//           calendars: ["month"],
//           tasks: [],
//         });
//       }
//     }
//   });
//   return { currentMissionEvents };
// };

export const formatSoftRequests = (requests, userId) => {
  return requests.map((request) => {
    const highPriority = request.value > 5;
    return {
      eventId: request.id,
      eventTitle: "Soft Time Off",
      start: new Date(`${request.date}T08:00:00`),
      end: new Date(`${request.date}T09:00:00`),
      type: "softRequest",
      highPriority,
      employeeIds: [userId],
      isAllDay: true,
    };
  });
};

export const formatTimeOff = (requests, userId) => {
  return requests.map((request) => {
    const name = request.employee.firstName + " " + request.employee.lastName;
    const personal = parseInt(request.employee.id) === parseInt(userId);

    const newRequest = {
      eventId: request.id,
      eventTitle: `${name} - ${request.type.name}`,
      type: "timeOff",
      status: request.approvedby ? "approved" : "pending",
      category: personal ? "personal" : "employee",
      employeeIds: [request.employee.id],
      approvedby: request.approvedby,
      workHours: request.workHours,
      typeId: request.type.id,
      comment: request.comment,
      deniedText: request.deniedText,
      createdAt: request.createdAt,
    };

    if (request.startTime && request.endTime) {
      newRequest.start = new Date(`${request.firstday} ${request.startTime}`);
      newRequest.end = new Date(`${request.lastday} ${request.endTime}`);
      newRequest.isAllDay = false;
    } else {
      newRequest.start = new Date(`${request.firstday}T08:00:00`);
      newRequest.end = new Date(`${request.lastday}T08:00:00`);
      newRequest.isAllDay = true;
    }
    return newRequest;
  });
};
